import type { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController, ModalController, Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { Preferences } from '@capacitor/preferences';

import * as _ from 'lodash-es';
import { Subscription } from 'rxjs';

import { SiteService } from '../services/site.service';
import { AccessControllerService, DeviceControllerService } from '../shared/typescript-angular-client';
import { UserSiteControllerService } from '../shared/typescript-angular-client/api/userSiteController.service';

import { UserService } from './../services/user.service';
import { SyncComponent } from './sync/sync.component';

@Component({
  selector: 'app-site',
  templateUrl: './site.page.html',
  styleUrls: ['./site.page.scss'],
})
export class SitePage implements OnInit {
  public sites = [];
  public siteSearched: any[] = [];
  public accessCount: number;
  public devicesCount: number;
  public user: any;
  public isRoleUserOnly = false;
  public blocks = [];
  public apiOk = false;
  public limit = 5;
  private subUserSite: Subscription;
  constructor(
    private userSiteApi: UserSiteControllerService,
    private userService: UserService,
    private accessApi: AccessControllerService,
    private deviceApi: DeviceControllerService,
    private storage: Storage,
    private router: Router,
    private menu: MenuController,
    private siteService: SiteService,
    private modalController: ModalController,
    public platform: Platform
  ) { }

  async ngOnInit(): Promise<void> {
    // console.log('INIT OVERWIEW');
    // console.log('SITE A');

    this.menu.enable(false);
    // this.storage.get('userInfos').then((u) => {
    //   this.user = u;
    // console.log('u:', u);
    // this.initSites();
    // });
    // console.log('platform: ', this.platform.platforms());
  }

  ionViewWillEnter(): void {
    // console.log('SITE B');
    this.apiOk = false;
    this.siteSearched = [];
    this.sites = [];
    this.menu.enable(false);
    this.userService.refreshUserInfos().then(() => {
      // this.storage.get('userInfos').then((u) => {
      Preferences.get({ key: 'userInfos' }).then((u) => {
        this.user = u;
        // console.log('u:', u);
        this.initSites().then(() => {
          this.apiOk = true;
        });
      });
    });
  }

  async ionViewWillLeave(): Promise<void> {
    await this.userService.refreshUserInfos();
  }

  private async initSites() {
    new Promise(async (resolve) => {
      this.siteService.unsetSite().then(() => {
        console.log('unsetSiteFromSite');
        this.storage.get('userInfos').then(async (userInfos) => {
          //Use cached data if any, then update cache with API data
          console.log('Getting sites from cache');
          this.storage.get('sites').then((data) => {
            console.log('Cached sites:', JSON.stringify(data));
            this.siteSearched = data;
            this.sites = data;
            const userId = userInfos.id;
            const filter = {
              order: 'properties.name ASC',
              where: { 'properties.app': 'solupass' },
            };
            this.userSiteApi.userSiteControllerFind(userId, JSON.stringify(filter)).subscribe({
              next: (sites) => {
                this.storage.set('sites', sites);
                if (sites.length < 1) {
                  this.router.navigate(['/home']);
                } else if (sites.length === 1) {
                  this.router.navigate(['/site/' + sites[0].id + '/overview']);
                } else {
                  this.siteSearched = sites.slice(0, 5);
                  this.sites = sites;
                  this.isRoleUserOnly = sites.filter(
                    (s) => userInfos.permissions.sites[s.id] && userInfos.permissions.sites[s.id].role !== 'user'
                  ).length
                    ? false
                    : true;
                  console.log('test ok');
                  return resolve(true);
                }
              },
              error: async (err) => {
                const storedSites = await this.storage.get('userSites');
                if (!storedSites || (storedSites && storedSites.expires <= _.now())) {
                  // console.log('test failed');
                } else {
                  // console.log('test ok');
                  if (storedSites.sites.length === 1) {
                    this.router.navigate(['/site/' + storedSites.sites[0].id + '/overview']);
                  } else {
                    this.siteSearched = storedSites.sites;
                    this.sites = storedSites.sites;
                    this.isRoleUserOnly = storedSites.sites.filter(
                      (s) => userInfos.permissions.sites[s.id] && userInfos.permissions.sites[s.id].role !== 'user'
                    ).length
                      ? false
                      : true;
                    console.log('test ok');
                    return resolve(true);
                  }
                }
              }
            });
          });
        });
      });
      if (
        this.user.email === 'unittest6@loopback.io' ||
        this.user.email === 'fmrichiardi@groupe-inoveo.fr' ||
        this.user.email === 'ngrange@u-link.fr' ||
        this.user.email === 'jturello@u-link.fr' ||
        this.user.email === 'apalermo@u-link.fr' ||
        this.user.email === 'fm@fm.fr' ||
        this.user.email === 'ngrange@groupe-inoveo.fr'
      ) {
        const where = {
          'properties.endDate': { gte: new Date().toISOString() },
        };
        const accessesCount = (await this.accessApi.accessControllerCount(JSON.stringify(where)).toPromise()).count;
        const devicesCount = (await this.deviceApi.deviceControllerCount().toPromise()).count;
        this.blocks = [
          {
            name: 'access',
            class: 'card rounded white-bg',
            icon: 'assets/Contour-Acces-DuoGris.svg',
            title: 'SITE.OVERVIEW.ACCESSES.HEADER',
            txt: 'SITE.OVERVIEW.ACCESSES.DESC',
            count: accessesCount,
            color: '',
            links: [
              // {
              //   name: 'SITE.OVERVIEW.ACCESSES.CREATEBTN',
              //   shortName: 'SITE.OVERVIEW.ACCESSES.CREATEBTNSHORT',
              //   redirect: 'addAccess',
              //   icon: 'assets/+Orange.svg'
              // },
              {
                name: 'SITE.OVERVIEW.ACCESSES.LISTBTN',
                redirect: 'accessesList',
                icon: 'assets/>Orange.svg',
              },
            ],
          },
          {
            name: 'device',
            class: 'card rounded white-bg',
            icon: 'assets/Contour-Cylindres.svg',
            title: 'SITE.OVERVIEW.DEVICES.HEADER',
            txt: 'SITE.OVERVIEW.DEVICES.DESC',
            count: devicesCount,
            color: '',
            links: [
              {
                name: 'SITE.HOME.DEVICEALL.CREATEBTN',
                redirect: 'devicesCreate',
                icon: 'assets/>Orange.svg',
              },
              {
                name: 'SITE.OVERVIEW.DEVICES.LISTBTN',
                redirect: 'devicesList',
                icon: 'assets/>Orange.svg',
              },
            ],
          },
          {
            name: 'organization',
            class: 'card rounded white-bg',
            iconName: 'briefcase',
            title: 'Organisations',
            color: '',
            links: [
              {
                name: 'Gérer',
                redirect: 'organization',
                icon: 'assets/>Orange.svg',
              },
            ],
          },
        ];
      }
      // provisoire
      // if (this.user.email !== 'unittest6@loopback.io'
      //   && this.user.email !== 'fmrichiardi@groupe-inoveo.fr'
      //   && this.user.email !== 'ngrange@u-link.fr'
      //   && this.user.email !== 'jturello@u-link.fr'
      //   && this.user.email !== 'apalermo@u-link.fr'
      //   && this.user.email !== 'fm@fm.fr'
      //   && this.user.email !== 'ngrange@groupe-inoveo.fr'
      //   && this.user.email !== 'amaury@yruama.fr') {

      //   this.blocks = [];
      // }
    });
  }

  private async getAccessCount() {
    const accesses = (await this.accessApi.accessControllerFind().toPromise()).filter(
      (a) => a.properties.endDate >= new Date().toISOString()
    );
    this.accessCount = accesses.length;
  }

  private async getDevicesCount() {
    this.devicesCount = (await this.deviceApi.deviceControllerCount().toPromise()).count;
  }

  public search(searchbar: any): void {
    this.siteSearched = [];

    const input = searchbar.srcElement.value.toLowerCase();

    this.siteSearched = this.sites.filter((obj) => {
      let find = false;
      Object.keys(obj.properties).forEach((key) => {
        const value = obj.properties[key];
        if (value && typeof value === 'string' && value.toLowerCase().includes(input)) {
          find = true;
        }
      });
      return find;
    });
  }

  public detail(siteId: number): void {
    this.router.navigate(['site/detail/' + siteId]);
  }

  public redirect(name: string): void {
    switch (name) {
      case 'addAccess':
        this.router.navigate(['access/create']);
        break;
      case 'accessesList':
        this.router.navigate(['access/']);
        break;
      case 'scan':
        this.scan();
        break;
      // case 'addDevice':
      //   this.router.navigate(['site/' + this.site.id + '/device/assignment']);
      //   break;
      case 'devicesList':
        this.router.navigate(['/device']);
        break;
      case 'organization':
        this.router.navigate(['/organization/']);
        break;
      case 'devicesCreate':
        this.router.navigate(['/device/create']);
        break;
      // case 'collabList':
      //   this.router.navigate(['site/detail/' + this.site.id + '/1']);
      //   break;

      default:
        break;
    }
  }

  async scan(): Promise<void> {
    console.log('scan for user:', this.user.email);
    let modal: any;
    modal = await this.modalController.create({
      componentProps: {
        from: 'site',
        installMode: this.userService.isSuperAdmin(this.user.email) ? true : false, //install mode
      },
      // component: this.isSuperAdmin() ? SyncComponent : ScanComponent,
      component: SyncComponent,
    });

    return await modal.present();
  }
}
